import React from 'react'
import AdvertisePage from '@shared/components/AdvertiseData'

const Advertise = () => {
  return (
      <AdvertisePage/>
  )
}

export default Advertise
